/*
|--------------------------------------------------------------------------
| MANTRAROMA – SMART ACCESSORIES
|--------------------------------------------------------------------------
| Version: 1.0.0
| Datum: 06.07.2026
|
| Kettenauswahl, Warenkorb-Übergabe, Preiszusammenfassung und Bildgruppen.
|--------------------------------------------------------------------------
*/

document.addEventListener('DOMContentLoaded', () => {
  const accessories = document.querySelector('[data-mantraroma-accessories]');
  const form = document.querySelector('[data-mantraroma-product-form]');
  if (!accessories || !form) return;

  const originalIdInput = form.querySelector('[name="id"]');
  const chainInputs = accessories.querySelectorAll('input[name="mantraroma-chain"]');
  const lengthFieldset = accessories.querySelector('.mantraroma-chain-lengths');
  const lengthInputs = accessories.querySelectorAll('input[name="mantraroma-chain-length"]');
  const variantData = accessories.querySelectorAll('[data-mantraroma-chain-variant]');
  const mainVariantData = document.querySelectorAll('[data-mantraroma-main-variant]');

  function getPriceSummary() {
    return document.querySelector('[data-mantraroma-price-summary]');
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function getCurrentMainVariantData() {
    const currentVariantId = originalIdInput?.value;

    return [...mainVariantData].find(
      (item) => item.dataset.mainVariantId === currentVariantId
    );
  }

  function getMainPrice() {
    return Number(getCurrentMainVariantData()?.dataset.mainVariantPrice || 0);
  }

  function getMainSku() {
    return getCurrentMainVariantData()?.dataset.mainVariantSku || '';
  }

  function clearAccessoryInputs() {
    form.querySelectorAll('[data-mantraroma-cart-input]').forEach((el) => el.remove());
    if (originalIdInput) originalIdInput.disabled = false;
  }

  function addHiddenInput(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-mantraroma-cart-input', '');
    form.appendChild(input);
  }

  function getSelectedChain() {
    return accessories.querySelector('input[name="mantraroma-chain"]:checked');
  }

  function getSelectedLength() {
    return accessories.querySelector('input[name="mantraroma-chain-length"]:checked');
  }

  function getSelectedGalleryGroup() {
    return getSelectedChain()?.dataset.mantraromaGalleryGroup || 'original';
  }

function normalizeValue(value) {
  return String(value || '').trim().toLowerCase();
}

function getVariantForLength(chainType, length) {
  const normalizedChainType = normalizeValue(chainType);
  const normalizedLength = normalizeValue(length);

  return [...variantData].find((item) =>
    normalizeValue(item.dataset.chainType) === normalizedChainType &&
    normalizeValue(item.dataset.chainVariantTitle) === normalizedLength
  );
}

  function getSelectedAccessoryVariant() {
    const selectedChain = getSelectedChain();
    const selectedLength = getSelectedLength();

    if (!selectedChain || selectedChain.value === 'cord' || !selectedLength) return null;

    const variant = getVariantForLength(selectedChain.value, selectedLength.value);
    if (!variant || variant.dataset.chainAvailable !== 'true') return null;

    return {
      id: Number(variant.dataset.chainVariantId),
      price: Number(variant.dataset.chainPrice)
    };
  }

  function updateDisplayedPrice() {
    const priceSummary = getPriceSummary();
    const chainPriceEl = priceSummary?.querySelector('[data-mantraroma-chain-price]');
    const totalPriceEl = priceSummary?.querySelector('[data-mantraroma-total-price]');
    const accessory = getSelectedAccessoryVariant();

    if (!priceSummary || !chainPriceEl || !totalPriceEl || !accessory) {
      if (priceSummary) priceSummary.hidden = true;
      return;
    }

    chainPriceEl.textContent = formatMoney(accessory.price);
    totalPriceEl.textContent = formatMoney(getMainPrice() + accessory.price);
    priceSummary.hidden = false;
  }

  function getMediaFileName(mediaItem) {
    const img = mediaItem.querySelector('img');
    const src = img?.currentSrc || img?.src || '';
    return decodeURIComponent(src).toLowerCase();
  }

  function mediaMatchesGroup(mediaItem, sku, galleryGroup) {
    const fileName = getMediaFileName(mediaItem);
    const normalizedSku = sku.toLowerCase();

    if (!fileName || !normalizedSku) return true;

    if (fileName.includes('-category')) return false;

    return (
      fileName.includes(normalizedSku) &&
      fileName.includes(`-${galleryGroup}-`)
    );
  }

  function updateGalleryImages() {
    const sku = getMainSku();
    const galleryGroup = getSelectedGalleryGroup();
    const gallery = document.querySelector('media-gallery');

    if (!gallery || !sku) return;

    const mediaItems = gallery.querySelectorAll(
      '.slider__item[data-media-id], .product-media-collage__item[data-media-id]'
    );

    const thumbnailItems = gallery.querySelectorAll(
      '.thumbnails .slider__item[data-media-id]'
    );

    const allItems = [...mediaItems, ...thumbnailItems];

    const matchingItems = allItems.filter((item) =>
      mediaMatchesGroup(item, sku, galleryGroup)
    );

    if (!matchingItems.length) {
      allItems.forEach((item) => {
        const fileName = getMediaFileName(item);
        item.hidden = fileName.includes('-category');
      });
      return;
    }

    allItems.forEach((item) => {
      item.hidden = !mediaMatchesGroup(item, sku, galleryGroup);
      item.classList.remove('is-active');
      item.removeAttribute('tabindex');
    });

    const firstMainItem = [...mediaItems].find((item) => !item.hidden);
    const firstMediaId = firstMainItem?.dataset.mediaId;

    if (!firstMediaId) return;

    gallery
      .querySelectorAll(`[data-media-id="${CSS.escape(firstMediaId)}"]`)
      .forEach((item) => item.classList.add('is-active'));

    const firstThumbnailLink = gallery.querySelector(
      `.thumbnails .slider__item[data-media-id="${CSS.escape(firstMediaId)}"] a`
    );

    if (firstThumbnailLink) {
      setTimeout(() => firstThumbnailLink.click(), 0);
    }
  }

  function updateLengthState() {
    const selectedChain = getSelectedChain();

    clearAccessoryInputs();

    if (!selectedChain || selectedChain.value === 'cord') {
      lengthFieldset.hidden = true;
      lengthInputs.forEach((input) => {
        input.checked = false;
        input.disabled = true;
      });
      updateDisplayedPrice();
      updateGalleryImages();
      return;
    }

    lengthFieldset.hidden = false;

    let firstAvailableInput = null;
    let checkedStillAvailable = false;

    lengthInputs.forEach((input) => {
      const variant = getVariantForLength(selectedChain.value, input.value);
      const isAvailable = variant && variant.dataset.chainAvailable === 'true';
      const label = accessories.querySelector(`label[for="${input.id}"]`);

      input.disabled = !isAvailable;
      if (label) label.classList.toggle('opt-label--is-unavailable', !isAvailable);

      if (isAvailable && !firstAvailableInput) firstAvailableInput = input;
      if (input.checked && isAvailable) checkedStillAvailable = true;
    });

if (!checkedStillAvailable) {
  lengthInputs.forEach((input) => {
    input.checked = false;
  });

  if (firstAvailableInput) {
    firstAvailableInput.checked = true;
  }
}

    updateDisplayedPrice();
    updateGalleryImages();
  }

  form.addEventListener('submit', () => {
    clearAccessoryInputs();

    const accessory = getSelectedAccessoryVariant();
    if (!accessory || !originalIdInput) return;

    const mainVariantId = originalIdInput.value;
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? quantityInput.value || 1 : 1;

    originalIdInput.disabled = true;

    addHiddenInput('items[0][id]', mainVariantId);
    addHiddenInput('items[0][quantity]', quantity);
    addHiddenInput('items[1][id]', accessory.id);
    addHiddenInput('items[1][quantity]', quantity);
  }, true);

  chainInputs.forEach((input) => input.addEventListener('change', updateLengthState));
  lengthInputs.forEach((input) => input.addEventListener('change', updateDisplayedPrice));

  /*
|--------------------------------------------------------------------------
| MANTRAROMA CUSTOM
| Version: 1.1.0
| Datum: 15.09.2026
| Zweck: Galerie ohne Zwischenanzeige aller Variantenbilder filtern.
|--------------------------------------------------------------------------
*/
document.addEventListener('on:variant:change', () => {
  updateDisplayedPrice();
  updateGalleryImages();
});

  updateLengthState();
});